
import { Link } from "react-router-dom";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { useEffect, useState } from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface ChannelCardProps {
  channel: {
    id: number | string;
    name: string;
    thumbnailUrl?: string;
    logoLight?: string;
    logoDark?: string;
    logo_light?: string; // Support both naming conventions
    logo_dark?: string;  // Support both naming conventions
    logo?: string;       // Fallback for legacy data
  };
}

export const ChannelCard = ({ channel }: ChannelCardProps) => {
  const { theme } = useTheme();
  const [refreshKey, setRefreshKey] = useState(Date.now());
  
  useEffect(() => {
    setRefreshKey(Date.now());
  }, [theme]);
  
  const logoUrl = theme === 'dark' 
    ? channel.logoDark || channel.logo_dark || channel.logo || "/placeholder.svg" 
    : channel.logoLight || channel.logo_light || channel.logo || "/placeholder.svg";

  return (
    <Link to={`/channel/${channel.id}`} className="group">
      <Card className="overflow-hidden transition-all duration-300 hover:shadow-md h-full">
        <div className="relative overflow-hidden bg-secondary/20">
          <AspectRatio ratio={16/9}>
            <div className="absolute inset-0 flex items-center justify-center p-6">
              <img 
                src={`${logoUrl}?t=${refreshKey}`}
                alt={channel.name}
                className="max-w-[95%] max-h-[95%] object-contain" // Increased size from 85% to 95%
                loading="lazy"
              />
            </div>
          </AspectRatio>
          <div className="absolute bottom-3 right-3 bg-white/90 dark:bg-black/70 text-primary rounded-full p-2 shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
            <ArrowRight className="h-4 w-4" />
          </div>
        </div>
        <CardHeader className="p-3 pb-2">
          <CardTitle className="text-base line-clamp-2">
            {channel.name}
          </CardTitle>
        </CardHeader>
      </Card>
    </Link>
  );
};

export default ChannelCard;

